import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  rootContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    width: "100%",
    height: "60px",
    color: "#354a5f",

  },
  headingContainer: {
    display: "flex",
  },
  rightButtons: {
    marginRight: "20px"
  },
});
